import BuildConfig from '@/environment';
import i18n from '@/plugins/i18n';

export const getSettingsNavTabs = () => [
  {
    name: i18n.global.t('general'),
    path: 'general',
  },
  {
    name: i18n.global.t('application'),
    path: 'serviceSettings',
  },
  {
    name: i18n.global.t('user-and-role-administration'),
    path: 'userAdmin',
  },
  {
    name: i18n.global.t('setting.dbCustomQuery'),
    path: 'customQueryOverview',
  },
  {
    name: i18n.global.t('setting.license-management'),
    path: 'licenseManagement',
  },
  {
    name: i18n.global.t('notifications'),
    path: 'notifications',
    hide: !BuildConfig.VUE_APP_SETTING_NOTIFICATION_ENABLE,
  },
];

const settings = {
  key: 'settings',
  name: i18n.global.t('settings'),
  icon: 'settings',
  navTabs: getSettingsNavTabs(),
};
export default settings;
